import ReactPlayer from "react-player";

export const SoundCloud = () => {
  return (
    <div className="home headerContainer">
      <ReactPlayer
        width={300}
        url="https://soundcloud.com/gospel144/sets/radiogospel"
      />
    </div>
  );
};
